"use client";

import Link from "next/link";
import { XLogo } from "@phosphor-icons/react";

import { Tag } from "@shared/ui/tag";

import { AnimatedBackground } from "~/components/animated-background";
import { JoinWaitListForm } from "~/components/join-waitlist-form";
import { AnimatedGroup } from "~/components/motion-primitives/animated-group";

export function FooterSection() {
  return (
    <section className="relative overflow-hidden px-4 pt-20" id="join">
      <div className="absolute inset-x-0 top-0 -z-10 h-full bg-linear-to-b from-[#000A15]/100 to-[#000A15]/0" />
      <AnimatedBackground className="-top-64 -right-96 scale-75 md:-top-80 md:-right-44 md:scale-90" />
      <AnimatedBackground className="-top-[100%] -left-[400px] hidden scale-90 md:-left-64 lg:block" />
      <AnimatedGroup className="mb-40 flex flex-col items-center justify-center md:mb-60">
        <Tag type="utility">Coming Soon</Tag>
        <h1 className="my-6 max-w-5xl text-center text-2xl font-semibold md:text-3xl md:leading-16 lg:text-4xl">
          Stop letting cloud costs stifle your innovation
        </h1>

        <p className="text-static-secondary mb-12 max-w-sm px-2 text-center text-base leading-7 md:max-w-4xl md:text-xl">
          Join the Tenki waitlist today for early access to our platform and be among the first to explore everything
          our cloud runner has to offer from day one
        </p>
        <JoinWaitListForm />
      </AnimatedGroup>

      <footer className="mx-auto max-w-5xl border-t border-white/20 pb-16">
        <div className="flex flex-col items-center justify-between gap-8 pt-[18px] md:flex-row">
          <div className="flex flex-wrap justify-center gap-6 text-sm">
            <Link
              href="https://x.com/tenkicloud"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="X/Twitter"
              className="text-muted-foreground hover:text-primary block"
            >
              <XLogo size={24} />
            </Link>
          </div>
          <div className="flex flex-col gap-4 text-sm md:flex-row">
            {/* NOTE: Temporarily disabled */}
            {/* <div className="flex justify-center gap-6 text-center"> */}
            {/*   <span>Privacy Policy</span> */}
            {/*   <span>Terms of Use</span> */}
            {/* </div> */}
            <span className="text-center">© 2025 Tenki. All rights reserved</span>
          </div>
        </div>
      </footer>
    </section>
  );
}
